import { Box, Layer, Heading, Text, Anchor } from "grommet";

export const BuiltBy = ({ close }) => {
  return (
    <>
      {" "}
      <Layer
        responsive={false}
        animation="fadeIn"
        position="center"
        onClickOutside={close}
        modal
        margin="small"
        style={{ maxWidth: "100vw", maxHeight: "90vh" }}
      >
        <Box pad="medium" gap="small" width="fit">
          <Heading level={3} margin="none">
            Gratitude Journal Version 1.1
          </Heading>
          <Text>
            Designed & Built by{" "}
            <Anchor href="https://tommcl.co.uk/about" label="Tom" /> & Joe
          </Text>
        </Box>
      </Layer>
    </>
  );
};
